import * as yup from "yup";
import { translate } from "@td/shared_utils";
import * as fieldTypes from "../constants/fieldTypes";

export const schemaFactory = ({ fields }) => {
  const innerShape = {};

  if (fields.includes(fieldTypes.PRACTICE_TEAM)) {
    innerShape[fieldTypes.PRACTICE_TEAM] = yup.string()
      .required(translate(null, "provider_panel.form.fields.practice.errors", "required"))
      .nullable();
  }

  if (fields.includes(fieldTypes.STATES)) {
    innerShape[fieldTypes.STATES] = yup.array()
      .when(fieldTypes.IS_PRINCIPAL, (isPrincipal, schema) => {
        return isPrincipal
          ? schema.nullable()
          : schema.required(translate(null, "provider_panel.form.fields.states.errors", "required")).nullable()
      });
  }

  if (fields.includes(fieldTypes.MAX_PANEL)) {
    innerShape[fieldTypes.MAX_PANEL] = yup.number()
      .min(1, translate(null, "provider_panel.form.fields.max_panel.errors", "min_value"))
      .typeError(translate(null, "provider_panel.form.fields.max_panel.errors", "type_error"))
      .required(translate(null, "provider_panel.form.fields.max_panel.errors", "required"));
  }

  if (fields.includes(fieldTypes.ACCEPT_NEW_PATIENTS)) {
    innerShape[fieldTypes.ACCEPT_NEW_PATIENTS] = yup.bool()
      .required(translate(null, "provider_panel.form.fields.accept_new_patients.errors", "required"));
  }

  if (fields.includes(fieldTypes.NEW_PATIENT_STATES)) {
    innerShape[fieldTypes.NEW_PATIENT_STATES] = yup.array()
      .when(fieldTypes.ACCEPT_NEW_PATIENTS, (acceptNewPatients, schema) => {
        if (acceptNewPatients) {
          return schema.min(1, translate(null, "provider_panel.form.fields.new_patient_states.errors", "min_items"))
            .nullable();
        }

        return schema.nullable();
      });
  }

  if (fields.includes(fieldTypes.NEW_PATIENTS_DAILY_LIMIT)) {
    innerShape[fieldTypes.NEW_PATIENTS_DAILY_LIMIT] = yup.number()
      .min(1, translate(null, "provider_panel.form.fields.new_patients_daily_limit.errors", "min_value"))
      .typeError(translate(null, "provider_panel.form.fields.new_patients_daily_limit.errors", "type_error"))
      .required(translate(null, "provider_panel.form.fields.new_patients_daily_limit.errors", "required"));
  }

  return yup.object().shape(innerShape);
}
